// LoadingContext.tsx
import { createContext, useCallback, useContext, useState } from "react";
import CustomSpinner from "../components/CustomSpinner";

export const LoadingContext = createContext({
  state: 0,
  setState() {},
});

export const LoadingProvider = ({
  children,
  hideChildrenWhileLoading = false,
  blockInteraction = false,
}) => {
  const [state, setState] = useState(0);
  const loading = state > 0;

  return (
    <LoadingContext.Provider value={{ state, setState }}>
      <div style={{ position: "relative" }}>
        {/* Nếu đang loading và bật chế độ ẩn children → không render children */}
        <div
          style={
            blockInteraction && loading
              ? { pointerEvents: "none", userSelect: "none" }
              : undefined
          }
          aria-busy={loading || undefined}
        >
          {hideChildrenWhileLoading && loading ? null : children}
        </div>

        <CustomSpinner loading={loading} />
      </div>
    </LoadingContext.Provider>
  );
};

export function useLoading() {
  const { setState } = useContext(LoadingContext);

  const show = useCallback(() => {
    setState((prev) => prev + 1);
  }, [setState]);

  const hide = useCallback(() => {
    setState((prev) => Math.max(prev - 1, 0));
  }, [setState]);

  return [show, hide];
}



// import { createContext, useCallback, useContext, useEffect, useState } from 'react';
// import CustomSpinner from '../components/CustomSpinner';

// export const LoadingContext = createContext({
//    state: 0,
//    setState() {},
// });

// export const LoadingProvider = ({ children }) => {
//    const [state, setState] = useState(0);

//    useEffect(() => {
//       if (state <= 0) return;

//       const timer = setTimeout(() => {
//          setState(0);
//       }, 5000);

//       return () => {
//          clearTimeout(timer);
//       };
//    }, [state]);

//    return (
//       <LoadingContext.Provider value={{ state, setState }}>
//          {children}
//          <CustomSpinner loading={state > 0} />
//       </LoadingContext.Provider>
//    );
// };

// export function useLoading() {
//    const { setState } = useContext(LoadingContext);

//    const show = useCallback(() => {
//       setState((prev) => ++prev);
//    }, [setState]);

//    const hide = useCallback(() => {
//       setState((prev) => Math.max(--prev, 0));
//    }, [setState]);

//    return [show, hide];
// }
